import { FC } from 'react'
import Button from '../../../atoms/button/Button'
import Modal from '../Modal'
import './AlertModal.scss'

export type AlertModalType = 'success' | 'error' | 'info'

interface Props {
  open: boolean
  type?: AlertModalType
  title: string
  description: string
  buttonLabel?: string
  onAction?: () => void
  onClose: () => void
  secondaryButtonLabel?: string
  onSecondaryAction?: () => void
  secondaryLoading?: boolean
}

const alertIcons: Record<AlertModalType, string> = {
  error: '!',
  success: '\u2713',
  info: 'i'
}

const AlertModal: FC<Props> = ({
  open,
  type = 'info',
  title,
  description,
  buttonLabel = 'OK',
  onAction,
  onClose,
  secondaryButtonLabel,
  onSecondaryAction,
  secondaryLoading
}) => {
  const handleAction = () => {
    onAction?.()
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="xs"
      body={
        <div className="alert-modal">
          <div className={`alert-modal__icon alert-modal__icon--${type}`}>
            {alertIcons[type]}
          </div>
          <h3 className="alert-modal__title">{title}</h3>
          <p className="alert-modal__description">{description}</p>
          <Button
            appearance="primary"
            className="alert-modal__btn"
            onClick={handleAction}
          >
            {buttonLabel}
          </Button>
          {secondaryButtonLabel && onSecondaryAction && (
            <Button
              appearance="subtle"
              className="alert-modal__btn-secondary"
              onClick={onSecondaryAction}
              disabled={secondaryLoading}
            >
              {secondaryLoading ? 'Sending...' : secondaryButtonLabel}
            </Button>
          )}
        </div>
      }
    />
  )
}
export default AlertModal
